<div class="auth-page">
  <div class="auth-form-side">
    <div class="auth-card">
      <div class="auth-brand auth-brand--compact">
        <div class="auth-brand__icon">
          <img src="assets/vtt-logo.png" alt="Van Tonder Transport logo" />
        </div>
        <div class="auth-brand__copy">
          <span class="auth-brand__name">VTT</span>
          <span class="auth-brand__sub">Van Tonder Transport</span>
        </div>
      </div>

      <!-- State: forgotPassword -->
      <ng-container *ngIf="state === 'forgotPassword'">
        <div class="auth-heading">
          <h1>{{ mode === 'username' ? 'Recover your username' : 'Reset your password' }}</h1>
          <p>{{ mode === 'username' ? 'Enter your email and we\'ll send you your username' : 'Enter your email address and we\'ll send you a reset link' }}</p>
        </div>

        <form
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="onForgotSubmit()"
          class="auth-form"
        >
          <div class="auth-field">
            <label for="email">Email address</label>
            <input
              id="email"
              pInputText
              type="email"
              formControlName="email"
              placeholder="Enter your email"
              class="w-full"
              [class.p-invalid]="submitted && f.email.errors"
              (input)="clearError()"
              autocomplete="email"
            />
            <small
              class="auth-error"
              *ngIf="submitted && f.email.errors?.['required']"
            >
              Email is required
            </small>
            <small
              class="auth-error"
              *ngIf="submitted && f.email.errors?.['email']"
            >
              Please enter a valid email address
            </small>
          </div>

          <p-message
            *ngIf="error"
            severity="error"
            [text]="error"
            styleClass="w-full"
          ></p-message>

          <button
            pButton
            pRipple
            type="submit"
            [label]="mode === 'username' ? 'Send Username' : 'Send Reset Link'"
            icon="pi pi-send"
            iconPos="right"
            [loading]="loading"
            class="w-full p-button-primary auth-submit"
          ></button>

          <div class="auth-footer">
            <a routerLink="/login" class="auth-link">
              <i class="pi pi-arrow-left"></i>
              Back to sign in
            </a>
          </div>
        </form>
      </ng-container>

      <!-- State: requestSent -->
      <ng-container *ngIf="state === 'requestSent'">
        <div class="auth-status">
          <div class="auth-status__icon auth-status__icon--success">
            <i class="pi pi-envelope"></i>
          </div>
          <h1>Check your email</h1>
          <p *ngIf="mode === 'username'">
            We've sent your username to your email address.
          </p>
          <p *ngIf="mode !== 'username'">
            We've sent a password reset link to your email address. Follow
            the instructions to reset your password.
          </p>
        </div>

        <div class="auth-footer auth-footer--center">
          <a routerLink="/login" class="auth-link">
            <i class="pi pi-arrow-left"></i>
            Back to sign in
          </a>
        </div>
      </ng-container>

      <!-- State: resetPassword -->
      <ng-container *ngIf="state === 'resetPassword'">
        <div class="auth-heading">
          <h1>Set new password</h1>
          <p>Choose a strong password for your account</p>
        </div>

        <form
          [formGroup]="newPasswordForm"
          (ngSubmit)="onResetSubmit()"
          class="auth-form"
        >
          <div class="auth-field">
            <label for="password">New password</label>
            <input
              id="password"
              pInputText
              type="password"
              formControlName="password"
              placeholder="Enter new password"
              class="w-full"
              [class.p-invalid]="submitted && fn.password.errors"
              (input)="clearError()"
              autocomplete="new-password"
            />
            <small
              class="auth-error"
              *ngIf="submitted && fn.password.errors?.['required']"
            >
              Password is required
            </small>
          </div>

          <div class="auth-field">
            <label for="confirmPassword">Confirm new password</label>
            <input
              id="confirmPassword"
              pInputText
              type="password"
              formControlName="confirmPassword"
              placeholder="Confirm new password"
              class="w-full"
              [class.p-invalid]="submitted && fn.confirmPassword.errors"
              (input)="clearError()"
              autocomplete="new-password"
            />
            <small
              class="auth-error"
              *ngIf="submitted && fn.confirmPassword.errors?.['required']"
            >
              Please confirm your password
            </small>
          </div>

          <p-message
            *ngIf="error"
            severity="error"
            [text]="error"
            styleClass="w-full"
          ></p-message>

          <button
            pButton
            pRipple
            type="submit"
            label="Set New Password"
            icon="pi pi-check"
            iconPos="right"
            [loading]="loading"
            class="w-full p-button-primary auth-submit"
          ></button>
        </form>
      </ng-container>

      <!-- State: resetSent -->
      <ng-container *ngIf="state === 'resetSent'">
        <div class="auth-status">
          <div class="auth-status__icon auth-status__icon--success">
            <i class="pi pi-check"></i>
          </div>
          <h1>Password updated</h1>
          <p>
            Your password has been reset successfully. You can now sign in
            with your new password.
          </p>
        </div>

        <div class="auth-footer auth-footer--center">
          <a
            routerLink="/login"
            pButton
            pRipple
            class="p-button-primary auth-submit w-full"
            style="text-decoration:none; justify-content:center;"
          >
            Sign in
          </a>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="auth-showcase">
    <div class="auth-showcase__mark">
      <span class="auth-showcase__mark-icon"><img src="assets/vtt-logo.png" alt="Van Tonder Transport logo" /></span>
      <span class="auth-showcase__mark-text">VTT</span>
    </div>

    <div class="auth-showcase__copy">
      <span class="auth-showcase__eyebrow">Fleet Operations</span>
      <h2>Keep every vehicle accounted for.</h2>
      <p>
        Active issues, service history, and technical records for your whole
        fleet, in one workspace.
      </p>
    </div>

    <div class="auth-showcase__foot">Van Tonder Transport</div>

    <i class="pi pi-truck auth-showcase__watermark" aria-hidden="true"></i>
  </div>
</div>
